import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import types from './types';

const actions = {
  async getUsers({ commit }, payload) {
    try {
      commit(types.GET_USERS_START);
      const { limit, offset, companyId } = payload;
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.users}`,
        params: { limit, offset, companyId },
        isToken: true,
      });
      commit(types.GET_USERS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_USERS_FAILURE, message);
    }
  },
  async getPmUsers({ commit }, payload) {
    try {
      commit(types.GET_PM_USERS_START);
      const { limit, offset } = payload;
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.pmUsers}`,
        params: { limit, offset },
        isToken: true,
      });
      commit(types.GET_PM_USERS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_PM_USERS_FAILURE, message);
    }
  },
  async updateUser({ commit, dispatch }, payload) {
    try {
      commit(types.UPDATE_USER_START);
      const { user, limit, offset } = payload;
      const { id, ...rest } = user;
      await apiCall({
        type: 'PUT',
        url: `${URLS.users}/${id}`,
        body: rest,
        isToken: true,
      });
      commit(types.UPDATE_USER_SUCCESS);
      notificationWithIcon('success', 'account updated');
      dispatch('getUsers', { limit, offset, companyId: payload.companyId });
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.UPDATE_USER_FAILURE, message);
    }
  },
  async resetPassword(_, payload) {
    try {
      const { email } = payload;
      await apiCall({
        type: 'POST',
        url: URLS.resetPassword,
        body: { email },
        isToken: true,
      });
      notificationWithIcon('success', 'new password has been sent to account email');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async deleteUser({ commit, dispatch }, payload) {
    try {
      const {
        id, limit, offset, companyId,
      } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.users}/${id}`,
        isToken: true,
      });
      commit(types.DELETE_USER_SUCCESS);
      notificationWithIcon('success', 'account deleted');
      dispatch('getUsers', { limit, offset, companyId });
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.UPDATE_USER_FAILURE, message);
    }
  },
  async createUser(_, payload) {
    try {
      await apiCall({
        type: 'POST',
        url: URLS.users,
        isToken: true,
        body: payload,
      });
      notificationWithIcon('success', 'account created');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async changePassword(_, { user }) {
    try {
      await apiCall({
        type: 'POST',
        url: URLS.resetPasswordManually,
        isToken: true,
        body: user,
      });
      notificationWithIcon('success', 'account password changed');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async searchUsers({ commit }, payload) {
    try {
      commit(types.GET_USERS_START);
      const { limit, offset, searchField } = payload;
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.searchUsers}`,
        params: { limit, offset, searchField },
        isToken: true,
      });
      commit(types.GET_USERS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_USERS_FAILURE, message);
    }
  },
  async searchUserForPromoCode({ commit }, payload) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.userFindForPromoCode}${payload}`,
        isToken: true,
      });
      commit(types.GET_FIND_USER_FOR_PROMO_CODE_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_USERS_FAILURE, message);
    }
  },
  async searchUserById({ commit }, id) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.userFindForPromoCode}/${id}`,
        isToken: true,
      });
      commit(types.GET_FIND_USER_FOR_PROMO_CODE_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_USERS_FAILURE, message);
    }
  },
  async getUserById({ commit }, id) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.userById}/${id}`,
        isToken: true,
      });
      commit(types.GET_USER_BY_ID_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async getUserBillingInfo({ commit }, payload) {
    try {
      const { id } = payload;
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.userBillingInfo}/${id}`,
        isToken: true,
      });
      commit(types.GET_USER_BILLING_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async getUserShippingInfo({ commit }, payload) {
    try {
      const { id } = payload;
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.userShippingInfo}/${id}`,
        isToken: true,
      });
      commit(types.GET_USER_SHIPPING_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async saveUserAddressInfo(_, payload) {
    try {
      const { isBilling, ...rest } = payload;
      const url = isBilling ? URLS.userBillingInfo : URLS.userShippingInfo;
      await apiCall({
        type: 'PUT',
        url,
        isToken: true,
        body: rest,
      });
      notificationWithIcon('success', 'Address changed');
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
};

export default actions;
